export const displayLabelOnTopOfTheBar = {
  color: '#232323',
  anchor: 'end',
  align: 'end',
  font: {
    size: 11
  }
};
